import React from 'react';
import ContainerTemplate from '../../../components/template/Container';
import * as ROUTES from '../../../router/Routes';
import TiposNivelClasesView from './TiposNivelClasesView';

const module = () => {
  return (
    <ContainerTemplate active={ROUTES.tiposNivelClases} routes={[]}>
      <TiposNivelClasesView />
    </ContainerTemplate>
  );
};

export default module;
